<!--============================
=            VUEORGANIZED            =
=============================-->
<template>
  <!-- APEXCHARTS -->
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Vue Organization</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Basic</div>
          <div slot="card-body">
            <div>
              <organization-chart :datasource="ds"></organization-chart>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
import OrganizationChart from "vue-organization-chart";
import "vue-organization-chart/dist/orgchart.css";

export default {
  components: {
    BaseCard,
    BaseHeader,
    OrganizationChart
  },
  data() {
    return {
      ds: {
        id: "1",
        name: "Lao Lao",
        title: "general manager",
        children: [
          { id: "2", name: "Bo Miao", title: "department manager" },
          {
            id: "3",
            name: "Su Miao",
            title: "department manager",
            children: [
              { id: "4", name: "Tie Hua", title: "senior engineer" },
              {
                id: "5",
                name: "Hei Hei",
                title: "senior engineer",
                children: [
                  { id: "6", name: "Pang Pang", title: "engineer" },
                  { id: "7", name: "Xiang Xiang", title: "UE engineer" }
                ]
              }
            ]
          },
          { id: "8", name: "Hong Miao", title: "department manager" },
          { id: "9", name: "Chun Miao", title: "department manager" }
        ]
      }
    };
  }
};
</script>
<style>
.h-300 {
  height: 300px;
}
</style>

<!--====  End of VUEORGANIZED  ====-->
